import React from 'react';
import { usePlanningActualState } from '../Context/index';

const Markdown = ({ years, categoryItem }) => {
  const { checkVisible, getFieldValue, getTotalOfField } = usePlanningActualState();
  const markDownOptions = [
    {
      keyName: 'plannedMarkdown',
      name: 'Planned Markdown',
    },
    {
      keyName: 'actualMarkdown',
      name: 'Actual Markdown',
    },
  ];
  return (years ?? []).map((currentYear, yearIndex) => {
    return (
      <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
        <thead>
          <tr>
            {markDownOptions.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>
                      {currentYear}&nbsp;
                      {salesItem.name}
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {categoryItem?.subcategory &&
            categoryItem.subcategory.map((cat2Ele, iCat) => {
              return (
                <tr key={iCat}>
                  {markDownOptions.map((salesItem, i) => {
                    const isVisible = checkVisible(salesItem.keyName);
                    return (
                      isVisible && (
                        <td key={i}>{getFieldValue(salesItem.keyName, yearIndex, currentYear, cat2Ele.subcategoryId._id, categoryItem?.categoryId?._id)}</td>
                      )
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
        <tfoot>
          <tr>
            {markDownOptions.map((item, i) => {
              const isVisible = checkVisible(item.keyName);
              return (
                isVisible && (
                  <td key={i}>
                    <b>{getTotalOfField(item.keyName, yearIndex, currentYear, categoryItem?.categoryId?._id)}</b>
                  </td>
                )
              );
            })}
          </tr>
        </tfoot>
      </table>
    );
  });
};
export default Markdown;
